import { Link } from "react-router-dom";
import errorImage from "../../assets/img/404.png"; // Adjust the path based on your project structure

const NotFoundPage = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center">
      {/* Display Image Instead of H1 */}
      <img src={errorImage} alt="404 Error" className="img-fluid mb-3" style={{ maxWidth: "400px" }} />

      <p className="fs-5 text-muted">Oops! The page you are looking for does not exist.</p>

      <Link to="/" className="custom-btn mt-3">
        Go Back Home
      </Link>

      {/* Custom Button Styles */}
      <style>
        {`
          .custom-btn {
            display: inline-block;
            font-size: 21px;
            text-transform: uppercase;
            line-height: 130%;
            padding: 16px 65px;
            border-radius: 35px;
            text-align: center;
            border: none;
            background-color: #f8bf2a;
            color: #333;
            transition: all 0.2s ease;
            text-decoration: none;
          }
          .custom-btn:hover {
            background-color: #e6aa1f;
            color: #222;
          }
        `}
      </style>
    </div>
  );
};

export default NotFoundPage;
